import { CommandExecutor } from './command-executor';
import { DataFilter, DataFilterParameters } from './../../data-management/data-filters/filters/data-filter';

import * as TSE from 'ts-events';
import { FilterModel } from '@/components/filter/FilterModel';
import store from '@/store/store';

export interface FilterCommandParameters {
    filter: FilterModel;
}

export class FilterCommandExecutor extends CommandExecutor {
    public static commandExecutorCreated = new TSE.SyncEvent();
    private filter: DataFilter;
    constructor() {
        super();
        this.filter = store.state.dataFiltersManager.dataFilter;
        FilterCommandExecutor.commandExecutorCreated.post(this);
    }

    public requestExecute = (commandParameters: FilterCommandParameters) => {
        const parameters: DataFilterParameters = {
            enabled: true,
            filter: commandParameters.filter
        };
        this.filter.execute(parameters);
        this.notifyExecute(parameters);
    }

    public requestReset: any = () => {
        this.notifyReset({ enabled: true, filter: this.filter });
    }
}
